import paw from "../assets/paw.svg"

export const Footer = () => {
  return (
    <footer className="footer">
      <img src={paw} alt={"paw"} />
    </footer>
  )
}
